import { Locale } from "@redotech/crdb-enums/common/locale";
import { CATALOG_LOCALE_ENUM_VALUES } from "@redotech/redo-i18n-runtime/catalog-locale";

export const TRANSLATABLE_LANGUAGES = CATALOG_LOCALE_ENUM_VALUES.filter(
  (language) => language !== Locale.En,
);
